var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96136(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3288_8575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.75 0.916504H0.75V96.9165H96.75V0.916504Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1501 48.9166C80.1501 42.7063 78.3085 36.6354 74.8583 31.4717C71.408 26.308 66.504 22.2834 60.7664 19.9068C55.0288 17.5302 48.7153 16.9084 42.6243 18.12C36.5333 19.3315 30.9383 22.3221 26.547 26.7135C22.1556 31.1048 19.165 36.6998 17.9535 42.7908C16.7419 48.8818 17.3637 55.1953 19.7403 60.9329C22.1169 66.6705 26.1415 71.5745 31.3052 75.0248C36.4689 78.475 42.5398 80.3166 48.7501 80.3166C57.0779 80.3166 65.0646 77.0084 70.9533 71.1198C76.8419 65.2311 80.1501 57.2444 80.1501 48.9166Z",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 51.7669V27.5269",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6101 46.7769L58.7401 58.9069",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3501 48.9165H20.5901",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8401 48.9165H80.0801",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79 20.7566V17.5166",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 80.3167V77.0767",
    stroke: "#706E70",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3288_8575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.75 0.916504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96136);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_136.7371c1788f837a866fb584fc2003be5f.svg";
export { ForwardRef as ReactComponent };